import React from 'react';
// template components
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// images
import desktopImageWebp from './images/life-insurance-hero.webp';
import mobileImageWebp from './images/life-insurance-hero-mobile.webp';
// low res images
import { lowResImageDesktop, lowResImageMobile } from './lowResImages';
// styles
import { HeroSectionStyled } from './styles';

export default () => {
  return (
    <HeroSectionStyled
      sectionId='life-insurance-hero'
      productName='Life Insurance'
      headingText={<>Let&#39;s protect the ones <WidowBlock>you love.</WidowBlock></>}
      descriptionText={<>You&#39;ve worked hard to build a life you enjoy with the people you love. Now it&#39;s time to protect it all. And you won&#39;t have to wonder what type or how much life insurance you need&#8212;working with your advisor will make it easy.</>}
      ctaPrimary={{
        linkUrl: '/find-a-financial-advisor/',
        buttonText: 'Get insurance',
        ariaLabel: 'Get insurance with a financial professional.',
        children: '',
      }}
      backgroundImageAriaLabel='A girl blowing out birthday candles with her family'
      backgroundImageDesktop={desktopImageWebp.toString()}
      backgroundImageMobile={mobileImageWebp.toString()}
      backgroundImageDesktopLowRes={lowResImageDesktop}
      backgroundImageMobileLowRes={lowResImageMobile}
      backgroundVariant='lightB'
      themeType='lightTheme'
    />
  );
};
